<dashboardnav>
  <cradua-division
  [divisions]="divisions$ | async"
  (division)="onSubmitDivision($event)"
  (deleteDivisionEvent)="onDeleteDivision($event)"
  *ngIf="(isLoadingDivision$ | async ) === false"
  >
</cradua-division>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingDivision$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
